import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import '../components/list/List.css'
import '../shared/styles/header.css'

function SearchView(props) {
    const [searchResults, setSearchResults] = useState([])
    const [searchNoResults, setSearchNoResults] = useState(false)

    // take search string and look for results
    useEffect(() => {
        const lookForResults = () => {
            let condition = new RegExp(props.searchValue, 'i')
            const results = props.data.filter((item) => {
                return condition.test(item.name)
            })
            setSearchResults(results)
        }
        lookForResults()
    }, [props.searchValue, props.data])

    // See if there is any results and show if/if not
    useEffect(() => {
        if (searchResults.length <= 0) {
            setSearchNoResults(true)
        } else {
            setSearchNoResults(false)
        }
    }, [searchResults])

    const listAllItems = searchResults.map(item => {
        if (item.img === "") item.img = "img/no-photo.jpg"

            return (
                <Link to={item.slug} key={item.slug}>
                    <li className="itemInList">
                        <div>
                            <img src={item.img} alt={item.name}/>
                        </div>
                        <div>
                            {item.name}
                            {item.europe_only ? 
                                <>&nbsp;<img src="/img/europeflag.png" alt="Europe" /></> : 
                                null
                            }
                        </div>
                    </li>
                </Link>
            )
    })

    return (
        <>
            <div className="title">
                Resultat för: {props.searchValue}
            </div>
            {searchNoResults ? 
                <p>Inga resultat hittades</p>
            :
                <ul className="list">
                    {listAllItems}
                </ul>
            }
        </>
    )
}

export default SearchView